import { async_utils } from "./frfr-async-utils";
import { js_utils } from "./frfr-js-utils";


// const frfr_lib_changes_id = '/FRFR/frfr-rapidozi-dummy-utils.js/changes_id2025-10-20r1/';


/* 
FrFr FRIENDLY FRAMEWORK
frfr-rapidozi-dummy-utils
Version ID: 1a 2025-10-20r1
by 
// Please describe here if you customized this file
*/

/*
INSPIRACIJA
store
storage
warehouse

PORBLEMATIKA šta je zajedničko za ERF SRF resbox funcbox entbox entpack

***dmd_entities to su fetchabilni podaci koji komponenta dodbija dobija u fazama fetching/spiinner i ready arr
- da bi došlo do njih mora da se uradi fetch
zatim se to upisuje ili u lokalni state komponente ili u globalni redux state aplikacije
zatim komponenta čita jedno ili drugo u promenjivu dmd_entities
pri mountovanju komponente u useEfect pozivamo fetch
-- dakle trebaju nam sledeci elementi
- fecthRefresh funkcija
- dmd_entities promenjiva

Da bi fetchovanje bilo propisno, trebaju nam
- catcError(err) funkcija
- local_entities_update funkcija koja ce novi dmd da upise u local_entities
ili superdmd_entites...




*/

//
export const rapidozi_dummy_utils = {};
export const rapidozi_dummysmarty_utils = {};

/*
get entity by key
get enetity all

*/

//
rapidozi_dummy_utils.consts = {
  CREATE: 'CREATE',
  READ: 'READ',
  UPDATE: 'UPDATE',
  DELETE: 'DELETE',
  //
  GET: 'GET',
  PATCH: 'PATCH',
  PUT: 'PUT',
  UPSERT: 'UPSERT',
};


//
rapidozi_dummy_utils.lorem_ipsum_complete = 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.'; // length is 445 characters


//
rapidozi_dummy_utils.lorem_ipsum_generate = (size) => {
  let str = rapidozi_dummy_utils.lorem_ipsum_complete;
  if (size === 0) { // has explicit size argument zero
    return '';
  } else if (size > 0) { // has explicit size argument
    if (size === str.length) {
      return str; // return complete lorem ipsum text
    } else if (size < str.length) {
      return str.slice(0, size);
    } else { // CASE need to extend string
      //
      let exit = false;
      let is_maximum_iterations_reached = false;
      let i = 0;
      while (exit === false) {
        str += ' ' + rapidozi_dummy_utils.lorem_ipsum_complete;
        if (size < str.length || size === str.length) {
          // finished
          exit = true;
        }
        i++;
        if (i > 1000) {
          is_maximum_iterations_reached = true;
          exit = true;
        }
      }
      if (is_maximum_iterations_reached) {
        return str;
      } else {
        return str.slice(0, size);
      }
      //
    }
  } else { // no size argument or size <= 0 
    return str; // return complete lorem ipsum text
  }
};

//
// _smartydummy_db_warehouse
const _smartydummy_db_store = {};
//
const _smartydummy_db_create = (db_key) => {
  const db = _smartydummy_db_store[db_key] = {
    counter: 102,
    meta: {
      name: db_key,
      readme: 'creatyed by _smartydummy_db_create',
      db_structure_version: '1',
    },
    collections: {},
  };
  //
  return db;
};
//
const _smartydummy_db_get_smart = (db_key) => {
  let db;
  if (_smartydummy_db_store[db_key]) {
    db = _smartydummy_db_store[db_key];
  } else {
    db = _smartydummy_db_create(db_key);
  }
  return db;
};
const _smartydummy_db_table_create = (db, tablename) => {
  const table = db.collections[tablename] = [];
  //
  return table;
};
//
const _smartydummy_db_table_get_smart = (db, tablename) => {
  let table;
  if (db.collections[tablename] && Array.isArray(db.collections[tablename])) {
    table = db.collections[tablename];
  } else {
    table = _smartydummy_db_table_create(db, tablename);
  }
  return table;
};


//
rapidozi_dummysmarty_utils.item_to_arr = (item, multiplier) => {
  let _multiplier = 4;
  if (multiplier > 0) {
    _multiplier = multiplier;
  }
  let updatedEntities = [];
  if (true) {
    for (let i = 0; i < _multiplier; i++) {
      let new_item = null;
      try {
        new_item = js_utils.pure_clone_by_json(item);
      } catch (error) {
        // console.log('Invalid JSON string!');
      }
      updatedEntities = [...updatedEntities, new_item];
    }
  } else {
  }
  return updatedEntities;
};

//
rapidozi_dummysmarty_utils.multiplicate_entities = (entities, multiplier) => {
  let _multiplier = 4;
  if (multiplier > 0) {
    _multiplier = multiplier;
  }
  if (Array.isArray(entities)) {
    let updatedEntities = [];
    for (let i = 0; i < _multiplier; i++) {
      updatedEntities = [...updatedEntities, ...entities];
    }
    return updatedEntities;
  } else {
    return entities;
  }
};

//
rapidozi_dummysmarty_utils.multiplicate_smart = (item_or_arr, multiplier) => {
  if (Array.isArray(item_or_arr)) {
    return rapidozi_dummysmarty_utils.multiplicate_entities(item_or_arr, multiplier);
  } else {
    return rapidozi_dummysmarty_utils.item_to_arr(item_or_arr, multiplier);
  }
};


//
rapidozi_dummysmarty_utils.api_fetch = async () => {
  let temp_dummy_data = [];
  await async_utils.pause(500);
  return temp_dummy_data;
};


//
const smartydummy_backend_engine = {};

let delay = 500;

// TEMP
smartydummy_backend_engine.make_response = (backend_key, db_key, tablename) => {
  const dummy_res = {
    data: [],
  };
  return dummy_res;
};


// FRONTEND-DB SPECIAL INSTANCE (USING ENGINE)
// Every instance just storing database key and settings. All operation are done by same only engine.

// let dynamodummy_backend_special_instance = (db_key, dont_store) => {
export const smartydummy_backend_special_instance = (backend_key, options) => {
  let instance = {}; // new instance...
  // instance.db_key = db_key;
  instance.dont_store = false;
  /*
  if (dont_store === true) {
    instance.dont_store = true;
  }
  */
  instance.backend_key = backend_key;
  instance.db_key = backend_key;
  //
  instance.api_get_arr = async function (tablename) {
    /*
    let _payload = null;
    if (typeof payload !== 'undefined') {
      _payload = payload;
    }
    */
    let response = await smartydummy_backend_engine.make_response(instance.backend_key, instance.db_key, tablename); // GET METHOD
    // KORAK pauza za response servera
    await async_utils.pause(delay); // pravimo pauzu
    // RES
    return response;
  };
  instance.api_get_all = async function (tablename) {
    /*
    let _payload = null;
    if (typeof payload !== 'undefined') {
      _payload = payload;
    }
    */
    let response = await smartydummy_backend_engine.make_response(instance.backend_key, instance.db_key, tablename); // GET METHOD
    // KORAK pauza za response servera
    await async_utils.pause(delay); // pravimo pauzu
    // RES
    return response;
  };
  instance.api_create = async function (tablename, payload) {
    let _payload = null;
    if (typeof payload !== 'undefined') {
      _payload = payload;
    }
    let response = await smartydummy_backend_engine.make_response(instance.backend_key, instance.db_key, tablename); // POST METHOD
    // KORAK pauza za response servera
    await async_utils.pause(delay); // pravimo pauzu
    // RES
    return response;
  };
  instance.api_delete = async function (tablename, key) {
    let _payload = null;
    if (typeof payload !== 'undefined') {
      // _payload = payload; // TODO
    }
    let response = await smartydummy_backend_engine.make_response(instance.backend_key, instance.db_key, tablename); // DELETE METHOD
    // KORAK pauza za response servera
    await async_utils.pause(delay); // pravimo pauzu
    // RES
    return response;
  };
  //
  return instance;
};



// export { rapidozi_dummy_utils };
// exports.rapidozi_dummy_utils = rapidozi_dummy_utils; // Node.js named export